import { NavbarMenu } from '@root/core/interfaces';

export const ADMIN_FORWARDER_MENU: NavbarMenu[] = [
  {
    id: 1,
    name: 'Inbound',
    url: '/admin/forwarder/inbound'
  },
  { id: 2, name: 'Seller', url: '/admin/forwarder/seller' }
];
